// Een cache voor de zware cross-tenant padberekening, per sector.
//
// Waarom dit bestaat: `sectorTocPaths` scant `OutputEffects`, `TocMechanisms`,
// `Activities` en `Stakeholders` over ÁLLE tenants — grofweg duizenden
// leesacties per aanroep. En het tabblad 'TOC paden' is de landingsplek én
// unmount bij elke tabwissel, dus zonder cache betaalt één sessie die scan
// opnieuw bij elke terugkeer naar het tabblad.
//
// De promise wordt bewaard, niet het resultaat: twee componenten die tegelijk
// mounten delen dan één aanroep in plaats van er twee te doen. Zelfde recept
// als de catalogus-cache in `components/meetstandaard/EffectDatabase.js`.
//
// Een mislukte aanroep wordt NIET bewaard — anders blijft één storing de rest
// van de sessie hangen en lijkt het alsof er geen paden zijn.
//
// AI-CONTEXT: See docs/features/toc-paden-tab-intelligence.md

/** @type {Map<string, Promise<object>>} */
const cache = new Map()

/**
 * @param {string} key - Sector + de MSI-id's waarop gescand wordt
 * @param {() => Promise<object>} loader - Doet de daadwerkelijke aanroep
 * @returns {Promise<object>}
 */
export const cachedSectorPaths = (key, loader) => {
    if (!key) return loader()
    if (!cache.has(key)) {
        cache.set(key, loader().catch((err) => {
            cache.delete(key)
            throw err
        }))
    }
    return cache.get(key)
}

/** Alleen voor tests: de cache leeft anders over testgrenzen heen. */
export const clearSectorPathsCache = () => cache.clear()

export default cachedSectorPaths
